import React, { useRef } from 'react';
import { GestureResponderEvent, TouchableOpacity, TouchableOpacityProps } from 'react-native';

export interface TouchableOpacityWithMiddleClickProps extends TouchableOpacityProps {
    onMiddleClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export default function TouchableOpacityWithMiddleClick({ onPress, onMiddleClick, children, ...props }: TouchableOpacityWithMiddleClickProps) {
    const suppressPressRef = useRef(false);

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (e.button === 1 || e.ctrlKey || e.metaKey) {
            e.preventDefault();
            e.stopPropagation();

            suppressPressRef.current = true;

            onMiddleClick?.(e);
        }
    };

    const handlePress = (e: GestureResponderEvent) => {
        if (suppressPressRef.current) {
            // consumimos o onPress causado pelo middle/modifier click
            suppressPressRef.current = false;
            return;
        }
        onPress?.(e);
    };


    const TouchableWithMouseDown = TouchableOpacity as unknown as React.ComponentType<
        TouchableOpacityProps & {
            onMouseDown?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
        }
    >;

    return (
        <TouchableWithMouseDown
            onPress={handlePress}
            onMouseDown={handleMouseDown}
            activeOpacity={0.7}
            {...props}
        >
            {children}
        </TouchableWithMouseDown>
    );
}
